import { safeParseInt } from "@/utils";

export default {
    computed: {
        btnTypes() {
            return {
                noStart: 1, // 考试未开始
                examEd: 2, // 已考试
                restart: 3, // 重新考试
                examEnd: 4, // 已结束
                startExam: 5, // 开始考试
            }
        }
    },
    methods: {
        // 处理考试列表的按钮状态
        handleExams(examList) {
            examList.forEach(item => {
                // 判断是否进入一分钟倒计时
                let now = new Date().getTime();
                let date1 = new Date(item.BeginTime.replace(/-/g, "/"));
                let date2 = new Date(item.EndTime.replace(/-/g, "/"));
                date1 = date1.getTime();
                date2 = date2.getTime();

                // 考试是否及格
                const isPass = safeParseInt(item.ksScore) >= safeParseInt(item.PassScore)
                // 已考试过一次
                const examStarted = safeParseInt(item.kscount) > 0
                // 及格后禁止考试
                const passAndDisable = safeParseInt(item.PassAgain) === 1
                const examNum = parseInt(item.ExamNum)
                const ksCount = parseInt(item.kscount)
                // 当前时间在考试时间范围内
                if (
                    safeParseInt(now) > safeParseInt(date1) &&
                    safeParseInt(now) < safeParseInt(date2)
                ) {
                    // 如果限制了考试次数
                    if (examNum > 0) {
                        // 如果已考试次数在范围内
                        if ((examNum > ksCount) && (ksCount > 0)) {
                            if (passAndDisable && (isPass || parseInt(item.CanExam) === 1)) {
                                item.btnStatus = this.btnTypes.examEd;
                            } else {
                                item.btnStatus = this.btnTypes.restart;
                            }
                        } else if (safeParseInt(item.ExamNum) <= safeParseInt(item.kscount)) {
                            // 考试次数已达到限制
                            item.btnStatus = this.btnTypes.examEd
                        } else {
                            // 考试次数等于0
                            item.btnStatus = this.btnTypes.startExam
                        }
                    } else if (passAndDisable) { // 如果启用了考试及格限制
                        if (isPass || parseInt(item.CanExam) === 1) {
                            // 已及格
                            item.btnStatus = this.btnTypes.examEd
                        } else if (examStarted) {
                            // 未及格，并且考试过一次
                            item.btnStatus = this.btnTypes.restart
                        } else {
                            // 未及格，并且未开始考试
                            item.btnStatus = this.btnTypes.startExam
                        }
                    } else {
                        if (examStarted) {
                            item.btnStatus = this.btnTypes.restart
                        } else {
                            item.btnStatus = this.btnTypes.startExam
                        }
                    }
                } else if (now < date1) {
                    item.btnStatus = this.btnTypes.noStart;
                } else {
                    item.btnStatus = this.btnTypes.examEnd;
                }
            })
        },
        isNumber (val) {
            const reg = /^((?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?)?$/
            return reg.test(String(val))
        }
    },
}
